<template>
  <div class="details">
    <div class="head">
      <div class="title">{{ taskInfo.taskName }}</div>
      <div class="head-cont">
        {{ taskInfo.taskDetail }}
      </div>
      <div
        v-if="taskInfo.taskStatus === 3 || taskInfo.taskStatus === 5"
        class="time"
      >
        完成时间：{{ formatTime(taskInfo.finishTime) }}
      </div>
    </div>
    <div v-if="taskInfo.taskType === 4" class="cont" style="padding-bottom: 0;">
      <div class="title">客户手机号</div>
      <div v-for="(item, index) in list" :key="item.id" class="item">
        <div class="item-l">
          <div class="phone">{{ item.phoneNumber }}</div>
          <div class="state">
            <span>{{ item.taskStatusDesc }}</span>
            <span v-if="item.taskStatus === 5">（{{ item.notes }}）</span>
          </div>
        </div>
        <div class="item-r">
          <div
            v-if="item.taskStatus === 4"
            class="btn"
            @click="manualShutdown(item.id)"
          >
            手动关闭
          </div>
          <div
            v-if="item.taskStatus === 2 || item.taskStatus === 4"
            class="btn"
            @click="addFriendFn(item.id, index)"
          >
            添加好友
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="
        (taskInfo.taskType === 5 || taskInfo.taskType === 6) &&
          taskInfo.taskStatus !== 3 &&
          taskInfo.taskStatus !== 5
      "
      class="cont"
    >
      <div v-if="taskInfo.taskType === 5" class="title2">
        核验信息<span class="red">*</span>
      </div>
      <div v-if="taskInfo.taskType === 6" class="title2">
        内容<span class="red">*</span>
      </div>
      <van-field
        v-if="taskInfo.taskType === 5"
        v-model="message"
        rows="3"
        autosize
        label=""
        type="textarea"
        placeholder="填写检核信息，字数需大于 15 个字"
      />
      <van-field
        v-if="taskInfo.taskType === 6"
        v-model="message"
        rows="3"
        autosize
        label=""
        type="textarea"
        placeholder="内容字数需大于15个字"
        maxlength="500"
        show-word-limit
      />
      <div v-if="taskInfo.taskType === 5" class="title2">
        附件信息<span class="red">*</span>
      </div>
      <div v-if="taskInfo.taskType === 6" class="title2">
        附件（仅限图片类型）<span class="red">*</span>
      </div>
      <van-uploader
        v-if="taskInfo.taskType === 5"
        v-model="fileList"
        preview-size="100px"
        :before-read="beforeRead"
        :before-delete="beforeDelete"
      >
        <img src="@/assets/img/task/icon_upload.png" alt="" />
      </van-uploader>
      <van-uploader
        v-if="taskInfo.taskType === 6"
        v-model="fileList"
        accept=".png, .jpg, .jpeg"
        preview-size="100px"
        :before-read="beforeRead"
        :before-delete="beforeDelete"
      >
        <img src="@/assets/img/task/icon_upload.png" alt="" />
      </van-uploader>
    </div>
    <div
      v-if="
        (taskInfo.taskType === 5 || taskInfo.taskType === 6) &&
          (taskInfo.taskStatus === 3 || taskInfo.taskStatus === 5)
      "
      class="cont"
    >
      <div class="title2">核验信息<span class="red">*</span></div>
      <div class="txt">{{ taskDetail.describe }}</div>
      <div class="title2">附件信息<span class="red">*</span></div>
      <div class="pic-box">
        <img
          v-for="(item, index) in taskDetail.pictureList"
          :key="index"
          class="pic"
          :src="item"
          alt=""
          @click="previewImg(taskDetail.pictureList)"
        />
      </div>
    </div>
    <div
      v-if="
        (taskInfo.taskType === 5 || taskInfo.taskType === 6) &&
          taskInfo.taskStatus !== 3 &&
          taskInfo.taskStatus !== 5
      "
      class="btn-box"
    >
      <div
        class="btn"
        :class="message && fileList.length > 0 ? 'submit' : ''"
        @click="submitVerification"
      >
        提交
      </div>
    </div>
    <!-- 手动关闭弹窗 -->
    <van-popup v-model="showManualClose" class="closePopup">
      <div class="title">添加好友异常原因</div>
      <van-field
        :value="closeValue"
        label=""
        readonly
        clickable
        placeholder="请选择"
        @click="showPicker = true"
      />
      <div class="close-btn">
        <div class="btn" @click="showManualClose = false">取消</div>
        <div class="btn send" @click="onConfirmClose">确认</div>
      </div>
    </van-popup>
    <!-- 关闭原因选择器 -->
    <van-popup v-model="showPicker" position="bottom">
      <van-picker
        :columns="columns"
        value-key="name"
        show-toolbar
        @confirm="onConfirm"
        @cancel="showPicker = false"
      />
    </van-popup>
  </div>
</template>

<script>
import { Toast, ImagePreview } from "vant";
import {
  friendTaskListApi,
  finishTaskApi,
  checkTaskDetailApi,
  getFriendMobileApi,
  addFriendApi,
  getCosKeyApi,
  customizeTaskDetailApi,
} from "@/api/modules/task";
import { cosObj } from "@/utils/index";
import dayjs from "dayjs";
import wxSDK from "@/scripts/wxsdk";
import { browseEvent, pageClickEvent } from "@/utils/utils";

export default {
  name: "TaskDetails",
  data() {
    return {
      userInfo: JSON.parse(sessionStorage.getItem("userInfo")),
      taskInfo: JSON.parse(sessionStorage.getItem("taskInfo")),
      taskType: sessionStorage.getItem("taskType"), // 1添加好友、提交核验 2详情
      message: "",
      fileList: [],
      friendId: "",
      list: [],
      showManualClose: false, // 手动关闭弹窗
      closeValue: "", // 关闭原因展示
      showPicker: false, // 关闭原因选择器
      columns: [
        {
          id: 1,
          name: "好友申请不予通过",
        },
        {
          id: 2,
          name: "已成为好友",
        },
        {
          id: 3,
          name: "查询不到好友信息",
        },
        {
          id: 4,
          name: "其他原因",
        },
      ],
      exceptionReason: "", // 关闭原因
      cosKey: {}, // cos相关key
      attachmentInfo: "", // 附件信息
      taskDetail: {}, // 核验详情
      phoneList: [],
      startTime: dayjs(), // 开始时间
      page_url: window.location.href, // 页面链接
      page_id: window.location.pathname, // 页面唯一标识
    };
  },
  async created() {
    // 添加好友
    if (this.taskInfo.taskType === 4) {
      this.getFriendTaskList();
      await wxSDK.config(["navigateToAddCustomer"], ["navigateToAddCustomer"]);
    }
    // 打卡核验 未完成
    if (
      (this.taskInfo.taskType === 5 || this.taskInfo.taskType === 6) &&
      this.taskInfo.taskStatus !== 3 &&
      this.taskInfo.taskStatus !== 5
    ) {
      this.getCiKey();
    }
    // 打卡核验 已完成
    if (
      (this.taskInfo.taskType === 5 || this.taskInfo.taskType === 6) &&
      (this.taskInfo.taskStatus === 3 || this.taskInfo.taskStatus === 5)
    ) {
      this.getTaskDetail();
    }
  },
  mounted() {
    if (this.taskType === "1") {
      // 埋点 浏览开始
      browseEvent({
        tab_name: "任务", // tab名称
        page_name: "任务列表页", // 页面名
        page_url: this.page_url, // 页面链接
        page_id: this.page_id, // 页面唯一标识
        activity_id: this.taskInfo.id, // 任务ID
        activity_name: this.taskInfo.taskName, // 任务名称
        activity_type: this.taskInfo.taskTypeDesc, // 任务类型
        start_time: dayjs().format("YYYY-MM-DD HH:mm:ss"), // 开始时间
      });
    }
  },
  beforeDestroy() {
    if (this.taskType === "1") {
      // 埋点 浏览结束
      browseEvent({
        tab_name: "任务", // tab名称
        page_name: "任务列表页", // 页面名
        page_url: this.page_url, // 页面链接
        page_id: this.page_id, // 页面唯一标识
        activity_id: this.taskInfo.id, // 任务ID
        activity_name: this.taskInfo.taskName, // 任务名称
        activity_type: this.taskInfo.taskTypeDesc, // 任务类型
        end_time: dayjs().format("YYYY-MM-DD HH:mm:ss"), // 结束时间
        view_time: dayjs().diff(this.startTime, "second"), // 页面停留时长
      });
    }
  },
  methods: {
    // 格式化时间
    formatTime(finishTime) {
      return dayjs(finishTime).format("YYYY-MM-DD HH:mm");
    },
    // 获取coskey
    async getCiKey() {
      const res = await getCosKeyApi();
      if (res.code === 0) {
        this.cosKey = res.data;
      }
    },
    // 上传图片
    beforeRead(file) {
      console.log(file);
      if (
        file.type !== "image/jpeg" &&
        file.type !== "image/jpg" &&
        file.type !== "image/png"
      ) {
        Toast("请上传jpeg、jpg、png格式的图片");
        return false;
      }
      const names = file.name.split(".");
      const cosFn = cosObj(this.cosKey);
      cosFn.uploadFile(
        {
          Bucket: this.cosKey.bucket, // 填入您自己的存储桶，必须字段
          Region: this.cosKey.region, // 存储桶所在地域，例如ap-beijing，必须字段
          Key: `/task/${dayjs().format("YYYY-MM-DD")}/img/${
            names[0]
          }_${Date.now()}.${names[1]}`, // 存储在桶里的对象键，必须字段
          Body: file, // 必须，上传文件对象
        },
        (err, data) => {
          if (err) {
            console.log("上传失败", err);
          } else {
            console.log(11, data);
            console.log(22, this.fileList);

            // 上传成功
            if (!this.attachmentInfo) {
              this.attachmentInfo += data.Location;
            } else {
              this.attachmentInfo += "," + data.Location;
            }
          }
        }
      );
      return true;
    },
    // 删除图片
    beforeDelete(file, detail) {
      const arr = this.attachmentInfo.split(",");
      arr.splice(detail.index, 1);
      this.attachmentInfo = arr.join(",");
      return true;
    },
    // 提交核验信息
    async submitVerification() {
      if (this.message.length < 15) {
        Toast("填写信息字数需大于 15 个字");
        return false;
      }
      if (!this.attachmentInfo) return;
      if (this.taskInfo.taskType === 5) {
        // 提交核验
        const res = await finishTaskApi({
          checkInfo: this.message,
          attachmentInfo: this.attachmentInfo,
          taskId: this.taskInfo.id,
          tenantId: 120000,
        });
        if (res.code === 0) {
          // 埋点 提交检核
          pageClickEvent({
            button_name: "提交检核", // 按钮名称
            activity_id: this.taskInfo.id, // 任务ID
            activity_name: this.taskInfo.taskName, // 任务名称
            activity_type: this.taskInfo.taskTypeDesc, // 任务类型
            page_id: this.page_id, // 页面唯一标识
            page_url: this.page_url, // 页面链接
            page_name: "任务", // 页面名
            tab_name: "任务", // tab名称
          });
          Toast.success("提交成功");
          setTimeout(() => {
            this.$router.go(-1);
          }, 1000);
        }
      }
      if (this.taskInfo.taskType === 6) {
        // 提交反馈
        const res = await finishTaskApi({
          checkInfo: this.message,
          attachmentInfo:
            "/" +
            this.attachmentInfo
              .split("/")
              .slice(1)
              .join("/"),
          taskId: this.taskInfo.id,
          tenantId: 120000,
          isFeedback: this.taskInfo.isFeedback,
        });
        if (res.code === 0) {
          Toast.success("提交成功");
          // 埋点 提交反馈
          pageClickEvent({
            button_name: "提交反馈", // 按钮名称
            activity_id: this.taskInfo.id, // 任务ID
            activity_name: this.taskInfo.taskName, // 任务名称
            activity_type: this.taskInfo.taskTypeDesc, // 任务类型
            page_id: this.page_id, // 页面唯一标识
            page_url: this.page_url, // 页面链接
            page_name: "任务", // 页面名
            tab_name: "任务", // tab名称
          });
          setTimeout(() => {
            this.$router.go(-1);
          }, 1000);
        }
      }
    },
    // 获取核验详情
    async getTaskDetail() {
      if (this.taskInfo.taskType === 5) {
        const res = await checkTaskDetailApi({
          taskId: this.taskInfo.id,
        });
        if (res.code === 0) {
          this.taskDetail = res.data;
        }
      }
      if (this.taskInfo.taskType === 6) {
        const res = await customizeTaskDetailApi({
          taskId: this.taskInfo.id,
        });
        if (res.code === 0) {
          this.taskDetail = res.data;
        }
      }
    },
    // 获取添加好友列表
    async getFriendTaskList() {
      const res = await friendTaskListApi({
        pageIndex: 1,
        pageSize: 9999,
        taskId: this.taskInfo.id,
      });
      if (res.code === 0) {
        this.list = res.data.dataList;

        const listPromises = res.data.dataList.map(async (item) => {
          return await this.getFriendMobile(item.id);
        });
        this.phoneList = await Promise.all(listPromises);
      }
    },
    // 获取手机号
    async getFriendMobile(id) {
      const res = await getFriendMobileApi({ friendId: id });
      if (res.code !== 0) return;
      const textString = res.data.toString().replace(/[^\d]/g, "");
      return textString;
    },
    // 添加好友
    async addFriendFn(id, index) {
      // 尝试使用现代剪贴板 API
      await navigator.clipboard.writeText(this.phoneList[index]);
      Toast.success("复制成功");
      const addRes = await addFriendApi({ friendId: id, isApply: 1 });
      if (addRes.code === 0) {
        this.getFriendTaskList();
        // 埋点 添加好友
        pageClickEvent({
          button_name: "添加好友", // 按钮名称
          activity_id: this.taskInfo.id, // 任务ID
          activity_name: this.taskInfo.taskName, // 任务名称
          activity_type: this.taskInfo.taskTypeDesc, // 任务类型
          page_id: this.page_id, // 页面唯一标识
          page_url: this.page_url, // 页面链接
          page_name: "任务", // 页面名
          tab_name: "任务", // tab名称
        });
        setTimeout(async () => {
          await wxSDK.addFriend();
        }, 1000);
      }
    },
    // 手动关闭
    manualShutdown(id) {
      this.exceptionReason = "";
      this.closeValue = "";
      this.friendId = id;
      this.showManualClose = true;
    },
    // 选择关闭原因
    async onConfirm(value) {
      this.exceptionReason = value.id;
      this.closeValue = value.name;
      this.showPicker = false;
    },
    // 确认关闭原因
    async onConfirmClose() {
      if (!this.exceptionReason) return;
      const res = await addFriendApi({
        exceptionReason: this.exceptionReason,
        friendId: this.friendId,
        isApply: 0,
      });
      if (res.code === 0) {
        Toast.success("操作成功");
        this.showManualClose = false;
        this.getFriendTaskList();
      }
    },
    // 预览附件图片
    previewImg(urls) {
      ImagePreview(urls);
    },
  },
};
</script>

<style lang="less" scoped>
* {
  box-sizing: border-box;
}
.details {
  width: 100%;
  height: 100vh;
  padding: 10px 12px 80px;
  overflow: auto;
  .head {
    width: 100%;
    background: #ffffff;
    border-radius: 8px 8px 8px 8px;
    border: 1px solid #f2f2f2;
    margin-bottom: 10px;
    padding: 15px;
    .title {
      font-weight: 500;
      font-size: 15px;
      color: #333333;
      margin-bottom: 8px;
    }
    .head-cont {
      font-size: 14px;
      color: #666666;
    }
    .time {
      font-size: 12px;
      color: #999999;
      margin-top: 15px;
    }
  }
  .cont {
    width: 100%;
    background: #ffffff;
    border-radius: 8px 8px 8px 8px;
    border: 1px solid #f2f2f2;
    padding: 15px;
    .title {
      font-size: 12px;
      color: #999999;
    }
    .item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      height: 66px;
      background: #ffffff;
      border-radius: 8px 8px 0px 0px;
      border-bottom: 1px solid #f3f3f3;
      &:last-child {
        border-bottom: 0;
      }
      .item-l {
        .phone {
          font-weight: 500;
          font-size: 14px;
          color: #333333;
          margin-bottom: 4px;
        }
        .state {
          font-size: 12px;
          color: #999999;
          line-height: 14px;
        }
      }
      .item-r {
        display: flex;
        align-items: center;
        .btn {
          height: 25px;
          border-radius: 4px 4px 4px 4px;
          border: 1px solid #f26147;
          line-height: 24px;
          padding: 0 15px;
          font-size: 12px;
          color: #f26147;
          margin-left: 8px;
          cursor: pointer;
        }
      }
    }
    .title2 {
      font-weight: 500;
      font-size: 15px;
      color: #333333;
      margin-bottom: 8px;
    }
    .txt {
      font-size: 12px;
      color: #666666;
      line-height: 18px;
      margin-bottom: 24px;
    }
    .pic-box {
      display: flex;
      flex-wrap: wrap;
      .pic {
        width: 100px;
        height: 100px;
        border-radius: 4px 4px 4px 4px;
        margin-right: 8px;
        margin-bottom: 8px;
        &:nth-child(3n) {
          margin-right: 0;
        }
      }
    }
    ::v-deep .van-field {
      border-radius: 6px 6px 6px 6px;
      border: 1px solid #f2f2f2;
      margin-bottom: 24px;
      &::after {
        display: none;
      }
    }
    ::v-deep .van-uploader {
      .van-uploader__preview:nth-child(3n) {
        margin-right: 0;
      }
      img {
        width: 100px;
        height: 100px;
      }
    }
  }
  .btn-box {
    position: fixed;
    bottom: 25px;
    left: 0;
    width: 100%;
    padding: 0 15px;
    .btn {
      width: 100%;
      height: 42px;
      background: rgba(242, 97, 71, 0.3);
      border-radius: 8px;
      font-weight: 500;
      font-size: 14px;
      color: #ffffff;
      line-height: 42px;
      text-align: center;
      cursor: pointer;
    }
    .submit {
      background: #f26147;
    }
  }
  .red {
    color: red;
  }
  .closePopup {
    width: 310px;
    background: #ffffff;
    border-radius: 20px 20px 20px 20px;
    padding: 20px;
    .title {
      font-weight: 500;
      font-size: 16px;
      color: #333333;
      text-align: center;
      margin-bottom: 20px;
    }
    .close-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 20px;
      .btn {
        width: 131px;
        height: 33px;
        border-radius: 4px 4px 4px 4px;
        border: 1px solid #f2f2f2;
        font-size: 12px;
        color: #666666;
        line-height: 32px;
        text-align: center;
        cursor: pointer;
      }
      .send {
        border: 1px solid #f26147;
        color: #f26147;
        margin-left: 10px;
      }
    }
  }
}
</style>
